import { AiChargeHistory, loadAiHistory, getAiHistory } from "../components/AiChargeParse"
import { useEffect, useState } from 'react'
import { useSnapshot } from 'valtio'
import Api from '../state/Api'
import { AgmodalStore, bookingsStore, cargoStore, configStore, containerStore, contractsStore, dataListStore, loginStore } from '../state/CommonState'
import Utils from '../util/Utils'
import LCLChargeClientView from '../enquiry/LCLChargeClientView'
import ShipmentGraph, { graphNode } from '../my-actions/shipment-graph'
import BookingSchedule from './booking.schedule'
import { rtpStore } from './pricing-store'
import { Button } from '@mui/material'
import { ArrowDownwardRounded, ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import airlogoMap from '../schedules/air-logo'
import FCLChargeClientViewv2 from '../enquiryv2/FCLChargeClientView-v2'
import schLogoMap from '../enquiry/carrier-logo'
import AguserApi from '../state/AguserApi'
import EntityV2Api from '../state/entities-api'
import { ENTITY_STATUS, PERMISSIONS_NEW } from '../util/constants'
import { GenericSwitch } from '../components/ag-switch'
import EntityCreWarnPopup from '../mui-components/EntityCreWarnPopup'
import { cartingStore } from '../cartingorder/cartingStore'
import { enquiryStore } from '../enquiry/enquiry-data'
import { editStore } from '../quick-quotev3/editStore'
import { HistoryModal, ProceedPopup, ToggleButton } from '../enquiryv3/dummy-schedule-v3'
import Taskfiledisplay from '../mytasks/task-file-display'
import { FCLChargesComp } from '../mytasks/act-update-cost'
import FCLChargeClientViewv3 from '../enquiryv3/FCLChargeClientView-v3'
import { taskStore } from '../mytasks/task-store'
import MonApi, { GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI, GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';
import { airChargesBookingStore, chargesBookingStore1, chargesBookingValidationStore, fclChargesBookingStore } from '../mybooksv3/booking-commonstate'
import { chargesData1 } from '../StaticData'
import BookingsApi from '../state/bookings-api'
import { chargesValidationStore } from '../state/validation-stores'
import QuoteCalcV2 from '../util/quote-calc-v2'
import RoleUtils from '../util/RoleUtils'
import TenantUtils from '../util/tenant.utils'
import { useGlobalState } from '../GlobalState'
import { useMobile } from '../hooks/usemobile'
import { PricingContextProvider } from '../context/PricingContext'
import { FCLBookingPricingDetail } from '../pages/FCLBookingPricingDetail'
import { FCLMarginAlert, fclCostCharges, initFclCostList } from '../quick-quotev3/create.booking'

function _g(node) {
    let e = new graphNode()
    //Object.assign(e, { r1: 'r1', r2: 'r2', r3: 'r3', r4: 'r4' })
    Object.assign(e, node)
    e.isActive = true
    e.activelines = 2
    return e
}


export default function FCLPricingSchedule(props) {
    const [showCharges, setShowCharges] = useState(false)
    const [ptbVisible, setptbVisible] = useState(true)
    const [EntityCreationPopup, setEntityCreationPopup] = useState(false)
    const { changeCurrentMenu } = useGlobalState()
    const isMobile = useMobile()
    useSnapshot(contractsStore)
    useSnapshot(bookingsStore)
    let brec = bookingsStore.current
    useSnapshot(configStore)
    useSnapshot(rtpStore)
    useSnapshot(cartingStore)
    useSnapshot(enquiryStore)
    useSnapshot(editStore)
     const logo =`assets/${process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE}/logo_name.svg`;
    fetch(logo).then(res => res.blob()); 
    let hideme = props.hideme
    let cwfVisible = props.cwfVisible
    //if (!cwfVisible && !ptbVisible) setptbVisible(true)
    let rec = contractsStore.current
    if (props.contract) rec = props.contract
    let subscript = -1
    if (props.subscript >= 0) subscript = props.subscript
    let disableBookNow = false;
    let charges = props.pricingRec?.charges
    if( charges && ((charges["Pick-up Charges"]&& charges["Pick-up Charges"].total===0)||(charges["Delivery Charges"]&& charges["Delivery Charges"].total===0))){
disableBookNow = true
    }
    const [edit,setEdit] = useState(false)
        const [activeTab, setActiveTab] = useState('');
        const [showHistory, setShowHistory] = useState(false);
        const [cost, setCost] = useState(false);
        const [costdata, setCostdata] = useState({});
        const [showEdit, setShowEdit] = useState(false);
        const [open,setOpen] = useState(false)
    // Create Booking → Get Rates: Sell Rate / Cost Rate inside the route card (staff, FCL)
    const [rateTab, setRateTab] = useState('')
    const [costAlert, setCostAlert] = useState(null)
    const [, setCostSaved] = useState(0)
    const showRateTabs = props.createbooking && !props.noprice && !loginStore.isClient()
    // The cost table uses the shared fclChargesBookingStore.costlist, so only one route card edits it at a time
    const costRouteKey = `${subscript}:${props.schind?.ID ?? props.schind ?? ''}`
    const openCostEditor = () => {
        editStore.costRoute = costRouteKey
        containerStore.list = JSON.parse(JSON.stringify(rec.containerList || []))
        cargoStore.cargoList = JSON.parse(JSON.stringify(rec.cargoList || []))
        chargesBookingValidationStore.isNew = true
        let sell = rec.orginalchargesList
        if (!sell || sell.length === 0) {
            sell = []
            const add = (list, onaccount) => (list || []).forEach((e) => sell.push({ ...JSON.parse(JSON.stringify(e)), onaccount, id: sell.length + 1 }))
            add(rec.chargesList, 'On Your Account')
            add(rec.shipperchargesList, "Shipper's Account")
            add(rec.consigneechargesList, "Consignee's Account")
        }
        initFclCostList(rec, sell, sell.length)
    }
    const selectRateTab = (tab) => {
        if (tab === rateTab) return setRateTab('')
        if (tab === 'cost') openCostEditor()
        setRateTab(tab)
    }
    // Saves the cost on this route; Book Now carries it into the booking (agserver then auto-completes Update Cost)
    const applyCost = (l) => {
        ['costChargesList', 'costQuoteValue', 'costQuoteValueUSD', 'costProfit', 'costProfitPercentage', 'costMarginAlert', 'costApprovalTo'].forEach((f) => {
            if (l[f] !== undefined) rec[f] = JSON.parse(JSON.stringify(l[f]))
            else delete rec[f]
        })
        setCostSaved((n) => n + 1)
        configStore.setModalMessage(l.costChargesList ? 'Cost saved for this route. Click Book Now to book with this cost.' : 'Cost removed for this route.')
    }
    const saveCost = () => {
        chargesBookingValidationStore.isNew = false
        const l = JSON.parse(JSON.stringify(rec))
        const k = new QuoteCalcV2(l).recalc()
        l.quoteValue = k.quoteValue
        l.quoteValueUSD = k.quoteValueUSD
        if (!(k.quoteValue > 0)) return configStore.setModalMessage('This route has no sell value, so the margin cannot be checked.')
        const cost = fclCostCharges(l, rec.emptycontainerweight, () => setRateTab('cost'))
        if (cost === false) return
        if (cost && cost.alert) return setCostAlert({ ...cost, contract: l })
        applyCost(l)
    }
        
    async function chargesListDiff(type) {
        chargesValidationStore.onSaveBtnClicked();
        let chargesList
        if (type.indexOf("FCL") >= 0) {
            type = "FCL"
        }
        if (type.indexOf("FCL") >= 0) {
            fclChargesBookingStore.calculateChargesTotalsindex("list", contractsStore.current.emptycontainerweight);
            chargesList = fclChargesBookingStore.list;
        } else if (type.indexOf("Air") >= 0) {
            airChargesBookingStore.checktotal = airChargesBookingStore.checktotal + 1
            cargoStore.calculateCargoTotals()
            airChargesBookingStore.calculateChargesTotalsindex('list')
            chargesList = airChargesBookingStore.list;
        } else {
            chargesBookingStore1.checktotal = chargesBookingStore1.checktotal + 1
            cargoStore.calculateCargoTotals()
            chargesBookingStore1.calculateLCLChargesTotals()
            chargesList = chargesBookingStore1.list;
        }
        chargesList = chargesList?.filter(e => e.chargeDescription && e.currency)
        let result = bookingsStore?.current?.contract?.history?.length > 0 ? bookingsStore?.current?.contract?.history : [];
        let oldCharges = Utils.getChargeList(JSON.parse(JSON.stringify(bookingsStore.current)))
        result.push({ user: loginStore.email, old: oldCharges?.length > 0 ? oldCharges :[], new: chargesList.length>0?chargesList:[], updatedAt: Date.now() });
        if (chargesList.some(e => e.onaccount =='On Your Account' && e.total!=0 )){
            let clist = []
            let slist = []
            let cnlist = []
            if (bookingsStore.current.createdFromPricing || bookingsStore.current.contractNum == 'SPOT' || (bookingsStore.current.cartingsheetId != undefined && bookingsStore.current.cartingsheetId.length > 0)) {
                let nl = JSON.parse(JSON.stringify(chargesList.filter(e=>e.chargeDescription)))
                for (let i = 0; i < nl.length; i++) {
                    nl[i]['isIncluded'] = 'Yes'
                    if (nl[i]['onaccount'] == 'On Your Account') {
                        clist.push(nl[i])
                    } else if (nl[i]['onaccount'] == `Shipper's Account`) {
                        slist.push(nl[i])
                    } else {
                        cnlist.push(nl[i])
                    }
                }
            }
            let oldchargesList = bookingsStore.current.contract.chargesList
            bookingsStore.current.contract.chargesList = JSON.parse(JSON.stringify(chargesList))
            let k = new QuoteCalcV2(bookingsStore.current.contract).recalc()
            if (k.quoteValue != 0) {
                await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  '_id': bookingsStore.current._id,
  "contract.quoteValue": k.quoteValue,
  "contract.quoteValueUSD": k.quoteValueUSD,
  "contract.chargesList": clist,
  "contract.chargesList": clist,
  "contract.shipperchargesList": slist,
  "contract.consigneechargesList": cnlist,
  "contract.history": result,

  "contract.aiChargeHistory": getAiHistory("bookingCharges")
})
                BookingsApi.getBooking(bookingsStore.current._id, (data) => {
                    Object.assign(bookingsStore.current, data)
                })
                setEdit(false)
            } else {
                bookingsStore.current.contract.chargesList = JSON.parse(JSON.stringify(oldchargesList))
                configStore.setModalMessage(`On your account is empty.`);
            }
        }else{
            configStore.setModalMessage(`On your account is empty.`);
        } 
        
    }
    const onClose = () => {
        setEdit(false)
        BookingsApi.getBooking(bookingsStore.current._id, (data) => {
            contractsStore.current = data.contract
            Object.assign(bookingsStore.current, data)
        })
    }
          const onSubmit  = ()=>{
            chargesListDiff(contractsStore.current.shipmentType)
          }
           useEffect(()=>{
            let scope = contractsStore?.current?.shipmentScope?.split('-to-')
                    
            let l = []
               if (props.viewonly) {
              let type = contractsStore.current.shipmentType
                    
                    
                    if(JSON.stringify(containerStore.list)!=JSON.stringify(contractsStore.current.containerList)){
                        containerStore.list = JSON.parse(JSON.stringify(contractsStore.current.containerList))
                    }
                    if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(contractsStore.current.cargoList)){
                        cargoStore.cargoList = JSON.parse(JSON.stringify(contractsStore.current.cargoList))
                    }
                    let c 
                    if(bookingsStore?.current?.contract?.chargesList && bookingsStore?.current?.createdFromPricing){
                        c = Utils.getChargeList(JSON.parse(JSON.stringify(bookingsStore.current)))
                    }else{
                      c = contractsStore.current.chargesList
                    }
                     
                    console.log(activeTab,"activetab");
                    if(activeTab=='cost'){
                      c = []
                    }
                    if(c!=undefined && c.length==0 ){
                        chargesBookingValidationStore.isNew = true
                    }else{
                        if(type.indexOf("FCL") >= 0){
                            type = "FCL"
                        }
                        let k = JSON.parse(JSON.stringify(c))
                        if (type.indexOf("FCL") >= 0 && JSON.stringify(fclChargesBookingStore.list)!=JSON.stringify(k)) {
                        fclChargesBookingStore.initialLength = k.length;
                        fclChargesBookingStore.list = k;
                        } else if (type.indexOf("Air") >= 0 && JSON.stringify(airChargesBookingStore.list)!=JSON.stringify(k)) {
                        airChargesBookingStore.initialLength = k.length;
                        airChargesBookingStore.list = k;
                        } else if(JSON.stringify(chargesBookingStore1.list)!=JSON.stringify(k)) {
                        chargesBookingStore1.initialLength = k.length;
                        chargesBookingStore1.list = k;
                        }
                        }
                    }                
            },[JSON.stringify(contractsStore.current),activeTab,edit])
             const getcost = async () =>{
                    if(bookingsStore?.current?._id!='' && activeTab =='Cost'){
                        let l = await MonApi.apost(GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, {
  bookingNum: bookingsStore.current._id
})
                        if(l.length>0){
                            let l1 = await MonApi.apost(GET_MYACTIONS_APPROVAL_FOR_LOSS_PENDING_URI, {
  bookingNum: bookingsStore.current._id
})
                            if(l1.length>0){
                                l[0]['approvestatu'] = "PENDING"
                            }else{
                                l[0]['approvestatu'] = "APPROVE"
                            }
                            if(cost==false){
                                setCost(true)
                            }
                            if(JSON.stringify(l[0])!=JSON.stringify(costdata)){
                                setCostdata(l[0])
                            }
                        }else{
                            if(cost!=false){
                                setCost(false)
                            }
                        }
                    }
                }
                useEffect(()=>{
                    console.log(costdata,typeof costdata,"chekcing for costdata",activeTab);
                    getcost()
                    
                },[JSON.stringify(AgmodalStore),bookingsStore.current,taskStore.current,taskStore.triggerActionVisible,activeTab])

    useEffect(() => {
        console.log('shipperpda TYPE=', rtpStore.shipperpda)
        if (rtpStore.shipperpda == ' ') {
            rec.quoteValueDeduction = rec.oih
        } else {
            rec.quoteValueDeduction = 0
        }
    }, [rtpStore.shipperpda])
    useEffect(() => {
        if (subscript < 0) return
        let filterType = rtpStore.dpd != 'Direct Port Delivery' ? 'NDPD' : 'DPD'
        let e = rtpStore.records[subscript]
        //console.log('\n\n\nDPD TYPE=', filterType, e.additionalType)
        if (rtpStore.additionalsets) {
            let recs = rtpStore.additionalsets.filter(e1 => e.ID == e1.ID && e1.additionalType == filterType)
            //console.log('LENGTH=', recs.length)
            if (recs && recs.length) {
                rtpStore.records[subscript] = recs[0]
            }
        }
    }, [rtpStore.dpd])

    if (!rec) return <></>

    let e = { ...props.data }
    let isDummy = props.isDummy ? true : false
    //if (props.isDummy) return <div>{JSON.stringify(rec)}</div>
    if (props.isDummy) {
        e = {
            'por': rec.portOfReceipt,
            'pol': rec.portOfLoading,
            'pod': rec.portOfDischarge,
            'fpod': rec.finalPlaceOfDelivery,
            'rep': rec.reworkingPort,
            'VESSEL NAME': '',
            'VOYAGE': '',
            'STUFFING CUT OFF DATE': '',
            'ETD (POL)': '',
            'ETA (POD)': '',
            'CO-LOADER': ''
        }
    }
    let theSchedule = e
    if (!e['POR (CFS / ICD / PORT)']) e['POR (CFS / ICD / PORT)'] = e['POL']
    if(e['etapod']==0 && e['deta']!=undefined && e['deta'].length>0)  e['etapod'] = e['deta']
    let srec = {
        por: e.por,
        pol: e.pol,
        pod: e.pod,
        vessel: e['VESSEL NAME'],
        voyage: e['VOYAGE'],
        cutOffDt: e['STUFFING CUT OFF DATE'],
        etdPol: e['ETD (POL)'],
        etaPod: e['ETA (POD)'],
        coLoader: e['CO-LOADER']
    }
    const pod = { location: srec.pod }
    const por = { location: srec.por }
    const pol = { location: srec.pol }

    let showOrigin = false
    let showDestination = false
    if (rec.shipmentScope.toLowerCase().indexOf('door-') >= 0) showOrigin = true
    if (rec.shipmentScope.toLowerCase().indexOf('-door') >= 0) showDestination = true
    let etaDate = Utils.newDate(e.etapod)
    if (e.pod != e.fpod) etaDate = Utils.newDate(e.etafpod)
    let etdDate = Utils.newDate(e.etdpol)
    let days = Utils.getDays(etdDate, etaDate)

    let _date = (d,dt) => {
        if(dt != undefined && dt.length>0){
            return d+Utils.formatDateShort(new Date(dt))
        }else{
            return ""
        }
    }

    const name_voy = (d,i)=>{
        let l = ""
        if(d[`v${i}name`]!=undefined && d[`v${i}name`].trim().length>0){
            l = d[`v${i}name`]
        }
        if(d[`s${i}voy`]!=undefined && d[`s${i}voy`].trim().length>0){
            l = l + " ("+d[`s${i}voy`]+")"
        }
        return l
    }

    //console.log('LCLCOMPONENT***',srec, srec.por, srec.pol, por.location, pol.location)
    let graphnodes = []
    if (showOrigin) {
        graphnodes.push(_g({
            r2: rec.origin,
            graphic: 'origin'
        }))
    }
    graphnodes.push(_g({
        r1: (props.isDummy || !e.cutoffpor) ? '' : _date('Cut-off ',e.cutoffpor),
        r2: por.location,
        r3: (!props.isDummy) ? _date('ETD ',por.location !== pol.location ? e.etdpor : e.etdpol) : ''
    }))
    if (por.location !== pol.location) {
        graphnodes.push(_g({
            r1: (props.isDummy) ? '' : _date('ETA ',e.etapol),
            r2: pol.location,
            r3: (props.isDummy) ? '' : _date('ETD ', e.etdpol)
        }))
    }
    if (!isDummy) {
        graphnodes.push(_g({
            r1: name_voy(e,'1'),
            r2: e.r1code,
            transparent: true
        }))
        if (e.ts1name && e.ts1name.length) {
            graphnodes.push(_g({
                r1: _date('ETA ',e.ts1eta),
                r2: e.ts1name,
                r3: _date('ETD ',e.ts1etd)
            }))
            graphnodes.push(_g({
                r1: name_voy(e,'2'),
                r2: e.r2code,
                transparent: true
            }))
        }
        if (e.ts2name && e.ts2name.length) {
            graphnodes.push(_g({
                r1: _date('ETA ', e.ts2eta),
                r2: e.ts2name,
                r3: _date('ETD ',e.ts2etd)
            }))
            graphnodes.push(_g({
                r1: name_voy(e,'3'),
                r2: e.r3code,
                transparent: true
            }))
        }
    }

    graphnodes.push(_g({
        r1: (props.isDummy || !e.etapod) ? '' : _date('ETA ', e.etapod),
        r2: pod.location,
        r3: (props.isDummy || e.pod == e.fpod || !e.etdpod) ? '' : _date('ETD ', e.etdpod),
    }))
    if (e.pod != e.fpod) {
        graphnodes.push(_g({
            r1: (props.isDummy || !e.etafpod) ? '' : _date('ETA ', e.etafpod),
            r2: e.fpod
        }))
    }
    if (showDestination) {
        if(rec.destination2!=undefined && rec.destination2.length>0){
            graphnodes.push(_g({
                multidest:rec.multidest,
                r2: "Multiple",
                graphic: 'destination'
            }))
        }else{
            graphnodes.push(_g({
                r2: rec.destination,
                graphic: 'destination'
            }))
        }
    }

    let grandTotal = 0.0
    let voldis = 0.0
    rec['chargesList'].map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        if (e.chargeDescription == 'Volume Discount') {
            voldis = e.total * erate
            //grandTotal -= voldis
        }
        else if (e.isIncluded == 'Yes')
            grandTotal += e.total * erate
    })
    let usdRate = configStore.getExchangeRate('USD')
    let grandusd = grandTotal / usdRate
    let pricingRec = props.pricingRec
    let sss = props.pricingRec?.dummyContract
    let cscac
    if (rec.scac) cscac = rec.scac
    let airlogo = logo
    if (brec && brec.iata) airlogo = airlogoMap[brec.iata]
    let exrate = 0
    let perchargelable = ""
    let Ocean_Freight_amount_inr = 0
    let Ocean_Freight_amount_usd = 0
    if(rec.shipmentScope=="Port-to-Port"){
        for (let i = 0; i < rec.chargesList.length; i++) {
            if(rec.chargesList[i]['chargeDescription']=='Ocean Freight'){
                console.log("+++",rec.chargesList[i])
                exrate = configStore.getExchangeRateinr(rec.chargesList[i])
                let k = Object.keys(rec.chargesList[i])
                for (let j = 0; j < k.length; j++) {
                    if(k[j].indexOf("perWM")!=-1){
                        perchargelable = k[j].split('perWM')[0]
                        Ocean_Freight_amount_inr = rec.chargesList[i][k[j]]*exrate
                        if(rec.chargesList[i]['currency']=='USD'){
                            Ocean_Freight_amount_usd = rec.chargesList[i][k[j]]
                        }
                        j = k.length+1
                    }
                }
            }
        }
    }

    const showContract = () => {
        if (loginStore.isClient()) {
            if (pricingRec.set != 5) return true
            if (pricingRec.validTo != '' && pricingRec.set != 5) return true
        }
        return false
    }

    const booknow = ()=>{
        Utils.checkBookingBlocked({
            rec,
            shipmentType: 'FCL',
            onProceed: () => {
                if (loginStore.isClient() && configStore.currentSelectedEntity.entityId.length === 0){
                    setEntityCreationPopup(true)
                    return
                }

                EntityV2Api.viewEntity(rec.entityId, (data) => {
                    if (data.status === ENTITY_STATUS.DEACTIVATED) {
                        configStore.setModalMessage(`Entity ${data.entityName} is Deactivated , please Activate it for Procced to booking `)
                    }
                    else if (data.entityCountry.toLowerCase() === 'india' && (data.branch[0].gst.length < 1 || data.branch[0].branchAddresses[0].address < 1)) {
                        if (loginStore.isClient()) {
                            let dataObject = {
                                cb: data?.customer?.crossBorder?.relationshipManager,
                                dt: data?.customer?.domesticTransport?.relationshipManager
                            }

                            AguserApi.getProfile(dataObject, (data) => {
                                let message = "Please update your KYC before proceeding for the Booking. Please reach out to your Relationship Manager if you face any challenges "

                                if (data?.CB_User || data?.DT_User) {
                                    let user = data?.CB_User || data?.DT_User
                                    message += `${user?.firstName} on ${user?.phonePrefix} ${user?.phone} or ${user?.email}`
                                } else if (data?.PAT_User) {
                                    message += data?.PAT_User?.email
                                }

                                configStore.setModalMessage(message)
                            })
                        } else {
                            configStore.setModalMessage('Please Update at least one GST and address to place the Booking')
                        }
                    }
                    else if (data.entityCountry.toLowerCase() !== 'india' && data.tinNum.length < 1) {
                        configStore.setModalMessage('Please Update at least tin Number to place the Booking')
                    }
                    else {
                        rtpStore.routeSubscript = subscript
                        bookingsStore.initialize()
                        bookingsStore.current.schedule = theSchedule
                        bookingsStore.current.graphNodes = graphnodes
                        let rec1 = { ...rec }

                        if(enquiryStore.current.fba==="Yes"){
                            rec.warehouse = enquiryStore.current.warehouse;
                        }
                        //rec1.tc.push(...rec.temptc)
                        bookingsStore.current.contract = { ...rec }
                        //bookingsStore.current.contract.temptc = []
                        let filteredCharges = bookingsStore.current.contract.chargesList
                        /*if (rec.oih && rtpStore.shipperpda == ' ') {
                            filteredCharges = filteredCharges.filter(e => e.chargeDescription != 'Origin Inland Haulage')
                            bookingsStore.current.contract.quoteValueDeduction = rec.oih
                            bookingsStore.current.contract.oih = 0
                        }*/
                        if (rec.oih && rtpStore.shipperpda == ' ') {
                            bookingsStore.current.contract.oih = rec.oih
                        } else {
                            bookingsStore.current.contract.oih = 0
                        }
                        bookingsStore.current.contract.chargesList = [...filteredCharges]
                        bookingsStore.current.contract.quotationNum = 'SPOT'
                        bookingsStore.current.contractNum = 'SPOT'
                        bookingsStore.current.contractRefNum = 'SPOT'
                        bookingsStore.current.hasToShowDummySchedule = false
                        bookingsStore.current.emailid = loginStore.email
                        bookingsStore.current.createdFromPricing = true
                        console.log('\n\n***TC length=', bookingsStore.current.contract.tc.length, '***\n')
                        if (isDummy) bookingsStore.current.hasToShowDummySchedule = true

                        contractsStore.current = rec
                        hideme(true)
                        setptbVisible(false)
                        configStore.scheduleOrCarrierform = 'carrierform'

                    }
                })
            }
        })
    }
    return (
        <>
            {isMobile ? (
                <PricingContextProvider key={props.data?._id || subscript}>
                    <Mobilelayoutfclschedule rec={rec} {...props} />
                </PricingContextProvider>
            ) : (
                <div className="box" style={ { background :"#2A6ED4 !important" }}>
         { !EntityCreationPopup ? (<>
            {
                (pricingRec && (pricingRec.set == 5 || pricingRec.set == 6 || pricingRec.set == 6.1)) && <div  style={{ fontSize: '1.0rem', fontWeight: 'bold', color: '#F64' }}>
                    {
                        (pricingRec.validTo == '')  ? <div ><span style={{border: '1px solid black'}}>SPOT</span></div> :
                        <div>Rates valid till {_date("",pricingRec.validTo)}</div>
                    }
                </div>
            }
            {
                (pricingRec && pricingRec.validupto && pricingRec.validupto.trim().length>0)?
                <div>
                <div style={{ color: 'grey', width: '100%' }}>Valid for <strong>Shipped-on-Board</strong> upto</div>
                <div  style={{ fontSize: '1.0rem', fontWeight: 'bold', color: '#F64' }}>{Utils.formatDate(new Date(pricingRec.validupto))}</div>
            </div>:""
            }
            <div className="columns" style={{ fontSize: '0.8rem' }}>
                <div className="column is-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0px' }}>
                    {
                        (schLogoMap[cscac]) ?
                            <img src={schLogoMap[cscac]} alt={cscac} />
                            : <strong>{cscac}</strong>
                    }
                </div>
                <div className="column is-9">
                    {
                        (days!=undefined && Number(days)>0) ?
                            <>
                                <div style={{ color: 'grey', width: '100%', textAlign: 'center' }}>Tentative Ocean Transit Time</div>
                                <div style={{ fontSize: '0.9rem', width: '100%', textAlign: 'center' }}><strong>{e.transitTime} days</strong></div>
                            </>
                            :
                            <>{isDummy && <div style={{ color: 'grey', width: '100%', textAlign: 'center' }}>Schedule Awaited</div>}</>
                    }
                    <div >
                        <ShipmentGraph insidepricing={true} graphNodes={graphnodes} />
                    </div>
                </div>
                <div className='column is-2' style={{ textAlign: 'center' }}>
                    {
                                (!props.noprice)?<>
                    {
                        (rec.shipmentScope=="Port-to-Port" && rec.isCarting==undefined && brec.isUpload==undefined && brec.createbooking==undefined)?<>
                        <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(Ocean_Freight_amount_usd, 'USD')}<span style={{ fontSize: '0.6rem' }}> Per {perchargelable}</span></strong></div>
                        <div style={{ fontSize: '0.8rem' }}>{Utils.N(Ocean_Freight_amount_inr)}</div>
                        </>:
                        <>
                        {
                        (rec.quoteValue <= 0) ?
                            <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(grandTotal)}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(grandusd, 'USD')}</div>
                                {voldis!=0 && <div style={{ fontSize: '1.0rem' }}>(Less) Volume Discount <strong>{Utils.N(voldis)}</strong></div>}
                            </> : <>
                                <div style={{ fontSize: '1.0rem' }}><strong>{Utils.N(rec.quoteValue - Utils.toNum(rec.quoteValueDeduction))}</strong></div>
                                <div style={{ fontSize: '0.8rem' }}>{Utils.N(rec.quoteValueUSD, 'USD')}</div>
                            </>
                    }
                        </>
                    }
                    {/*
                        (voldis > 0) ?
                            <>
                                <div style={{ fontSize: '1.0rem' }}>(Less) Volume Discount <strong>{Utils.N(voldis)}</strong></div>
                            </> : <></>
                */}
                    {/*
                        (voldis > 0 && grandTotal - voldis > 0) ?
                            <>
                                <div style={{ fontSize: '1.0rem' }}>(Final Discounted Offer <strong>{Utils.N(grandTotal - voldis)}</strong></div>
                            </> : <></>
            */}
                    <div style={{ fontSize: '0.6rem', color: 'grey' }}>(Taxes, as Applicable)</div></>:""}
                    {
                        (props.createbooking)?<>
                        <div className="columns m-0 p-0">
                        <div className='column is-12 m-0 p-0'>
                    
                                <button className='button is-rounded islink is-small' onClick={() => {
                                     booknow()

                                }}>
                                    Book Now
                                </button>

                    </div>
                    </div>
                        </>:
                    <>{
                                (cartingStore.current._id!=undefined && cartingStore.current._id.length>0)?
                    <><div className="columns m-0 p-0">
                        <div className='column is-6 m-0 p-0'>
                                    {
                                        (!props.nobutton) ?
                                            <>
                                                <button disabled={disableBookNow} className='button is-rounded islink is-small' onClick={async () => {
                                                    editStore.contract = JSON.parse(JSON.stringify(rec))
                                                    editStore.subscript = props.subscript
                                                    editStore.schind = props.schind
                                                    editStore.setfclSchedule(e)
                                                    editStore.saveschedule = false
                                                    props.setOpenScheduleModel(true)
                                                }}>
                                                    Edit Schedule
                                                </button>
                                            </> : <></>
                                    }
                                </div>
                                <div className='column is-6 m-0 p-0'>
                                    {
                                        (!props.nobutton) ?
                                            <>
                                                <button disabled={disableBookNow} className='button is-rounded islink is-small' onClick={async () => {
                                                    editStore.contract = JSON.parse(JSON.stringify(rec))
                                                    editStore.subscript = props.subscript
                                                    editStore.schind = props.schind
                                                    editStore.savecharge = false
                                                    props.setOpenChargeModel(true)
                                                }}>
                                                    Edit Charge
                                                </button>
                                            </> : <></>
                                    }
                                </div>
                                </div>
                                <div className="columns m-0 p-0">
                    <div className='column is-12 m-0 p-0'>
                    {
                        (!props.nobutton && rtpStore.customerTBA != 'TBA') ?
                            <>
                                <button disabled={disableBookNow} className='button is-rounded is-small is-info' onClick={() => {
                                    Utils.checkBookingBlocked({
                                        rec,
                                        shipmentType: 'FCL',
                                        onProceed: () => {
                                            if (loginStore.isClient() && configStore.currentSelectedEntity.entityId.length === 0){
                                                setEntityCreationPopup(true)
                                                return
                                            }

                                            EntityV2Api.viewEntity(rec.entityId, (data) => {
                                                if (data.status === ENTITY_STATUS.DEACTIVATED) {
                                                    configStore.setModalMessage(`Entity ${data.entityName} is Deactivated , please Activate it for Procced to booking `)
                                                }
                                                else if (data.entityCountry.toLowerCase() === 'india' && (data.branch[0].gst.length < 1 || data.branch[0].branchAddresses[0].address < 1)) {
                                                    if (loginStore.isClient()) {
                                                        let dataObject = {
                                                            cb: data?.customer?.crossBorder?.relationshipManager,
                                                            dt: data?.customer?.domesticTransport?.relationshipManager
                                                        }

                                                        AguserApi.getProfile(dataObject, (data) => {
                                                            let message = "Please update your KYC before proceeding for the Booking. Please reach out to your Relationship Manager if you face any challenges "

                                                            if (data?.CB_User || data?.DT_User) {
                                                                let user = data?.CB_User || data?.DT_User
                                                                message += `${user?.firstName} on ${user?.phonePrefix} ${user?.phone} or ${user?.email}`
                                                            } else if (data?.PAT_User) {
                                                                message += data?.PAT_User?.email
                                                            }

                                                            configStore.setModalMessage(message)
                                                        })
                                                    } else {
                                                        configStore.setModalMessage('Please Update at least one GST and address to place the Booking')
                                                    }
                                                }
                                                else if (data.entityCountry.toLowerCase() !== 'india' && data.tinNum.length < 1) {
                                                    configStore.setModalMessage('Please Update at least tin Number to place the Booking')
                                                }
                                                else {
                                                    rtpStore.routeSubscript = subscript
                                                    bookingsStore.initialize()
                                                    bookingsStore.current.schedule = theSchedule
                                                    bookingsStore.current.graphNodes = graphnodes
                                                    let rec1 = { ...rec }
                                                    //rec1.tc.push(...rec.temptc)
                                                    bookingsStore.current.contract = { ...rec }
                                                    //bookingsStore.current.contract.temptc = []
                                                    let filteredCharges = bookingsStore.current.contract.chargesList
                                                    /*if (rec.oih && rtpStore.shipperpda == ' ') {
                                                        filteredCharges = filteredCharges.filter(e => e.chargeDescription != 'Origin Inland Haulage')
                                                        bookingsStore.current.contract.quoteValueDeduction = rec.oih
                                                        bookingsStore.current.contract.oih = 0
                                                    }*/
                                                    if (rec.oih && rtpStore.shipperpda == ' ') {
                                                        bookingsStore.current.contract.oih = rec.oih
                                                    } else {
                                                        bookingsStore.current.contract.oih = 0
                                                    }
                                                    bookingsStore.current.contract.chargesList = [...filteredCharges]
                                                    bookingsStore.current.contract.quotationNum = 'SPOT'
                                                    bookingsStore.current.contractNum = 'SPOT'
                                                    bookingsStore.current.contractRefNum = 'SPOT'
                                                    bookingsStore.current.hasToShowDummySchedule = false
                                                    bookingsStore.current.emailid = loginStore.email
                                                    bookingsStore.current.createdFromPricing = true
                                                    console.log('\n\n***TC length=', bookingsStore.current.contract.tc.length, '***\n')
                                                    if (isDummy) bookingsStore.current.hasToShowDummySchedule = true
                                                    let c = cartingStore.current
                                            let c1 = enquiryStore.current
                                            contractsStore.current = rec
                                                    let ct = ""
                                            if(c.invoiceDetails!=undefined && c.invoiceDetails.length>0){
                                                        let l = []
                                                for (let i = 0; i < c.invoiceDetails.length; i++) {
                                                            let k = c.invoiceDetails[i].commodityType
                                                            if(k != undefined && k.length>0){
                                                                l.push(k)
                                                            }
                                                        }
                                                        ct = l.join(',')
                                                    }
                                                    contractsStore.current.commodityType = ct
                                                    bookingsStore.current.contract.commodityType = ct
                                                    bookingsStore.current.commodityType = ct
                                                    contractsStore.current.salesperson = c.salesperson
                                                    contractsStore.current.customerService = c.customerService
                                                    bookingsStore.current.contract.salesperson = c.salesperson
                                                    bookingsStore.current.contract.customerService = c.customerService
                                                    bookingsStore.current.cartingsheetId = c._id
                                                    bookingsStore.current.commercialInvoice_filename_list = c.commercialInvoice_filename_list
                                                    bookingsStore.current.packingList_filename_list = c.packingList_filename_list
                                            bookingsStore.current.shippingBill_filename_list = c.shippingBill_filename_list
                                            bookingsStore.current.cartingPhotos_filename_list = c.cartingPhotos_filename_list
                                            bookingsStore.current.shippingBillchecklist_filename_list = c.shippingBillchecklist_filename_list
                                                    bookingsStore.current.mmSlip_filename_list = c.mmSlip_filename_list
                                                    bookingsStore.current.flexiBooking = true
                                                    bookingsStore.current.shipperCompany = c.shipperName
                                                    bookingsStore.current.shipperAddress = c.address
                                                    bookingsStore.current.contract.overHeight = c1.overHeight
                                                    bookingsStore.current.contract.overlength = c1.overlength
                                                    bookingsStore.current.contract.topLoading = c1.topLoading
                                                    bookingsStore.current.contract.fumigation = c1.fumigation
                                                    bookingsStore.current.contract.headLoad = c1.headLoad
                                                    bookingsStore.current.contract.doorLoad = c1.doorLoad
                                                    bookingsStore.current.contract.reefer = c1.reefer
                                                    bookingsStore.current.contract.overHeightValue = c1.overHeightValue
                                                    bookingsStore.current.contract.overlengthValue = c1.overlengthValue
                                                    bookingsStore.current.contract.procurement = ""
                                                    bookingsStore.current.contract.reworkingPort = c.reworkingPort
                                                    bookingsStore.current.contract.isCarting = "Yes"
                                                    bookingsStore.current.contract.nomination = c.nomination
                                            let cargo = []
                                            let md = bookingsStore.current.contract.multidest
                                            md.forEach(item => {
                                                cargo.push(...item.cargoDetails);
                                            });
                                            bookingsStore.current.contract.cargoList = JSON.parse(JSON.stringify(cargo))
                                                    let fclCarrierList = dataListStore["FCLCarrierList"];
                                                    if(fclCarrierList?.length>0) {
                                                        let carrierName = fclCarrierList.find((list)=>list["SCAC code"] === bookingsStore.current.contract.scac);
                                                        if(carrierName){
                                                            bookingsStore.current.contract.carrier = carrierName["Display Name"]
                                                        }
                                                    }
                                                    hideme(true)
                                                    setptbVisible(false)
                                                    configStore.scheduleOrCarrierform = 'carrierform'

                                                }
                                            })
                                            
                                        }
                                    })
                                }}>
                                    Claim Shipment
                                </button>
                            </> : <></>
                    }
                    </div>
                    </div></>:
                    <><div className="columns is-multiline m-0 p-0">
                        {
                            (!props.getquote)?<>
                    <div className='column is-6 m-0 p-0'>
                    {
                        (!props.nobutton && props.pricingRec) &&
                        <>
                            {
                                (!loginStore.isClient()) &&
                                <button className='button is-rounded is-small is-info' onClick={() => {
                                    if (rec.oih && rtpStore.shipperpda == ' ') {
                                        let pdatc = `Origin Inland Charges from ${rec.portOfReceipt} to ${rec.portOfLoading} are on Shipper's account`
                                        if (rec.oihScac != 'PRIVATE' && rec.oihScac != 'CONCUR') pdatc += ', subject to Carrier Approval'
                                        props.pricingRec.quote.quoteData.customTC += pdatc + "\n"
                                    }
                                    Api.saveQuoteNoTransform(props.pricingRec)
                                }}>Save Quote</button>
                            }
                            {
                                (showContract()) &&
                                <button className='button is-rounded is-small is-info' onClick={async () => {
                                     if (configStore.currentSelectedEntity.entityId.length === 0){
                                        setEntityCreationPopup(true)
                                        return
                                    }
                                    if (rec.oih && rtpStore.shipperpda == ' ') {
                                        let pdatc = `Origin Inland Charges from ${rec.portOfReceipt} to ${rec.portOfLoading} are on Shipper's account`
                                        if (rec.oihScac != 'PRIVATE' && rec.oihScac != 'CONCUR') pdatc += ', subject to Carrier Approval'
                                        props.pricingRec.quote.quoteData.customTC += pdatc + "\n"
                                    }
                                    await Api.saveQuoteAndContract(props.pricingRec, isDummy)
                                }}>Save Contract</button>
                                // <Button sx={{textTransform:"capitalize"}}>Save Contract</Button>
                            }
                        </>
                    }
                    </div>
                    <div className='column is-6 m-0 p-0'>
                    {
                        (!props.nobutton && rtpStore.customerTBA != 'TBA') ?
                            <>
                                <button disabled={disableBookNow} className='button is-rounded islink is-small' onClick={() => {
                                     booknow()

                                }}>
                                    Book Now
                                </button>
                            </> : <></>
                    }
                    </div>
                    {(TenantUtils.isNavexel()) && <div className={`column is-12 m-0 p-0`}>
                                                        {
                                                            (!props.nobutton) ?
                                                                <>
                                                                    <button  className='button is-rounded islink is-small' onClick={async () => {
                                                                        editStore.pricingRec = JSON.parse(JSON.stringify(props.pricingRec))
                                                                        props.setOpenCopyMail(true)
                                                                    }}>
                                                                        Copy Mail
                                                                    </button>
                                                                </> : <></>
                                                        }
                                                    </div>
                                                    }
                                                    </>:
                                                    <>
                                                    <div className='column is-12 m-0 p-0' style={{textAlign: 'center', 'justifyContent': 'center'}}>
                                                                                            <button className='button is-rounded is-small is-info' onClick={() => {
                                                                                                            const callback = (d)=>{
                                                                                                                
                                                                  AgmodalStore.pageVisible = false;
                                                                  changeCurrentMenu('Quotationv3')
                                                                  AgmodalStore.modalPage = 'Quotev3';
                                                                  AgmodalStore.pageVisible = true;
                                                                                                            }
                                                                                                            Api.saveQuoteNoTransform(props.pricingRec,false,true,false,callback)
                                                                                                        }}>Get Quote</button>
                                                                                                        </div>
                                                    </>
                        }
                    </div>
                    {/* <div className="columns m-0 p-0">
                                    <div className='column is-12 m-0 p-0'>
                                    {
                                        (!props.nobutton) ?
                                            <>
                                                <button disabled={disableBookNow} className='button is-rounded islink is-small' onClick={async () => {
                                                    editStore.contract = JSON.parse(JSON.stringify(rec))
                                                    editStore.subscript = props.subscript
                                                    editStore.schind = props.schind
                                                    editStore.setfclSchedule(e)
                                                    editStore.saveschedule = false
                                                    props.setOpenScheduleModel(true)
                                                }}>
                                                    Edit Schedule
                                                </button>
                                            </> : <></>
                                    }
                                </div>
                                </div> */}
                                
                                </>}</>}
                    
                    
                    <button style={{ marginTop: '5px' }} className="button is-inverted is-rounded is-small is-link" onClick={() => {
                        let rec1 = JSON.parse(JSON.stringify(rec))
                        rec1.tc.push(...rec.temptc)
                        if (rec.oih && rtpStore.shipperpda == ' ') {
                            let pdatc = `Origin Inland Charges from ${rec.portOfReceipt} to ${rec.portOfLoading} are on Shipper's account`
                            if (rec.oihScac != 'PRIVATE' && rec.oihScac != 'CONCUR') pdatc += ', subject to Carrier Approval'
                            rec1.tc.push(pdatc)
                        }
                        configStore.setModalMessage("", [], false, rec1.tc)
                    }}>Terms and Conditions</button>

                </div>
            </div>
            {props.showbooking == '1' ? <>
                        <div className="columns">
                                {RoleUtils.canViewBookingRevenueDetails() && <div className={RoleUtils.bookingDetailsColumnClass()} style={{ fontSize: "0.8rem" }}>
                                  <ToggleButton
                                    isOpen={activeTab == 'Revenue'}
                                    onClick={() =>{ 
                                      setActiveTab(activeTab == 'Revenue' ? '' : 'Revenue')
                                      setEdit(false)
                                    }}
                                    openText="View Revenue Details"
                                    closeText="Hide Revenue Details"
                                  />
                                </div>}
                                {RoleUtils.canViewBookingCostDetails() && <div className={RoleUtils.bookingDetailsColumnClass()} style={{ fontSize: "0.8rem" }}>
                                  <ToggleButton
                                    isOpen={activeTab == 'Cost'}
                                    onClick={() =>{ 
                                      setActiveTab(activeTab == 'Cost' ? '' : 'Cost')
                                      setEdit(false)
                                    }}
                                    openText="View Cost Details"
                                    closeText="Hide Cost Details"
                                  />
                                </div>}
                              </div>
                              <div className={activeTab === 'Revenue' || activeTab === 'cost' ? 'box' : ''} style={{ fontSize: '0.8rem' }}>
                                  {activeTab === 'Revenue' && (
                                    <div>
                                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                  
                                  <h4 className="title is-6" style={{ margin: 0 }}>Revenue Details</h4>
                              
                                  <div style={{ display: 'flex', gap: '10px' }}>
                                    {
                                        (!edit && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CHARGES) && bookingsStore?.current?.contract?.history?.length > 0) ?
                                        <button
                                          className="button "
                                          onClick={() => setShowHistory(true)}
                                          style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                        >
                                          History
                                        </button>:<></>
                                    }
                                        {
                                          (!edit && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_CHARGES) && bookingsStore?.current?.status != 'CANCELLED') ?
                                          <button className="button" onClick={()=>{
                                              loadAiHistory("bookingCharges", `${bookingsStore.current?._id}-${Date.now()}`, bookingsStore.current?.contract?.aiChargeHistory)

                                              setEdit(true)
                                          }} style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}>Edit</button>
                                          :<></>
                                        }
                                      </div>
                                      </div>
                                        {!edit && <AiChargeHistory history={rec?.aiChargeHistory} chargeKey="all" />}
                                        <div
                                          className="columns"
                                          style={{
                                            fontSize: "0.8rem",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            paddingTop:'20px'
                                          }}
                                        >
                                          {
                                            edit?
                                            (<FCLChargesComp type={'Edit Charges'} aiScope="bookingCharges" />):<>
                                            <div className='column is-6' style={{paddingTop:"0"}}>
                                                <FCLChargeClientViewv2 dummyContract={rec} subscript={subscript} />
                                            </div>
                                            <div className='column is-6' style={{paddingTop:"0"}}>
                                                {
                                                <>
                                                    {rec.shipperchargesList?.length > 0 &&(
                                                        <FCLChargeClientViewv2 dummyContract={rec} chargesName='shipperchargesList' />)
                                                    }
                                                    {rec.consigneechargesList.length > 0 && (
                                                        <FCLChargeClientViewv2 dummyContract={rec} chargesName='consigneechargesList' />)
                                                    }
                                                </>
                                                }
                                            </div>
                                            </>
                                          }
            
                                        </div>
                                        {
                                          edit?<div style={{display:'flex',justifyContent:'flex-end',gap:'10px'}}>
                                          <button onClick={()=>{
                                            onClose()
                                          }} className="button is-danger" >Cancel</button>
                                          <button onClick={()=>{
                                            setOpen(true)
                                          }} className="button is-link" >Save</button>
                                          </div>:<></>
                                        }        
                                    </div>
                                  )}
                              
                                {activeTab === 'Cost' && (
                                  <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                      <h4 className="title is-6" style={{ margin: 0 }}>Cost Details</h4>
                                    </div>
                                      <div
                                        className="columns"
                                        style={{
                                          fontSize: "0.8rem",
                                          display: "flex",
                                          flexDirection:'column',
                                          alignItems: "center",
                                          justifyContent: "center",
                                          paddingTop:'20px'
                                        }}
                                      >
                                        {(cost && costdata)?
                                        <>
                                           <FCLChargeClientViewv3 dummyContract={costdata}/> 
                                           <p><strong>Gross Profit value: </strong>{costdata.profit!=undefined?costdata.profit.toFixed(2):""}</p>
                                           <p><strong>Gross Profit percentage: </strong>{costdata.profit_percentage!=undefined?costdata.profit_percentage.toFixed(2):""}</p>
                                           {(costdata['approvestatu']!=undefined && costdata['approvestatu']=="PENDING") && <p><strong>Approval for Loss is in pending status.</strong></p>}
                                        {
                                          costdata?.files?.length > 0 &&
                                          (<Taskfiledisplay
                                         notshow={true} validation={true} task={costdata}/>) 
                                        } </>:(<h1>No Cost Data available</h1>)
                                      }
                                      </div>
                                  </div>
                                )}
                              </div>
                              { open && (
                                      <ProceedPopup open={open} close={()=>setOpen(false)} onClick={onSubmit}/>
                               )}
                            {showHistory && (
                                  <HistoryModal type={contractsStore?.current?.shipmentType} show={showHistory} title='Revenue History' data={bookingsStore?.current?.contract?.history || []} onClose={() => setShowHistory(false)}/>
                            )}
            </>: <>
            <div className="columns" style={{ fontSize: '0.8rem' }}>
                {
                            (!props.noprice && showRateTabs)?<>
                    <div className="column is-6" style={{ fontSize: '0.8rem' }}>
                        <ToggleButton isOpen={showCharges} openText="View Detailed Pricing" closeText="Hide Detailed Pricing"
                            onClick={() => { setShowCharges(!showCharges); setRateTab('') }} />
                    </div>
                    <div className="column is-6" style={{ fontSize: '0.8rem' }}>
                        <ToggleButton isOpen={rateTab === 'cost'} openText={rec.costChargesList?.length > 0 ? 'Edit Cost Rate' : 'Add Cost Rate'} closeText="Hide Cost Rate"
                            onClick={() => { setShowCharges(false); selectRateTab('cost') }} />
                    </div>
                    </>:
                            (!props.noprice)?<>{
                    (showCharges) ?
                        loginStore.isClient() ? <Button size='small' onClick={() => {
                            setShowCharges(false)
                        }} variant='contained' endIcon={<ArrowDropUp />} fullWidth sx={{
                            display: "flex", textTransform: "capitalize", alignItems: "center", backgroundColor: "#ffdc7d", color: "black", "&:hover": {
                                backgroundColor: "#ffdc7d"
                            }
                        }} >Hide Detailed Pricing</Button> : <button className='button is-warning is-small is-fullwidth' onClick={() => setShowCharges(false)}>
                            Hide Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-up"></i>
                            </span>
                        </button> :
                        loginStore.isClient() ? <Button size="small" onClick={() => {
                            setShowCharges(true)
                        }} variant='contained' endIcon={<ArrowDropDown />} fullWidth sx={{ textTransform: "capitalize", alignItems: "center" }} >View Detailed Pricing</Button> : <button className='button is-info is-small is-fullwidth'
                            onClick={() => {
                                setShowCharges(true)
                            }}>
                            View Detailed Pricing
                            <span className="icon" style={{ marginLeft: '5px' }}>
                                <i className="fas fa-sort-down"></i>
                            </span>
                        </button>
                        }</>:""
                }

            </div>
            {
                (!props.noprice && showCharges) ?
                    <>
                        <div className="columns" style={{
                            fontSize: '0.8rem',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            {
                                (rec.shipperchargesList?.length > 0 || rec.consigneechargesList?.length > 0) ?
                                    <>
                                        <div className='column is-6'>
                                            <FCLChargeClientViewv2 dummyContract={rec} subscript={subscript} cwfVisible={props.cwfVisible}/>
                                        </div>
                                        <div className='column is-6'>
                                            {
                                                rec.shipperchargesList?.length > 0 ?
                                                    <FCLChargeClientViewv2 dummyContract={rec} chargesName='shipperchargesList' />
                                                    :
                                                    <FCLChargeClientViewv2 dummyContract={rec} chargesName='consigneechargesList' />
                                            }
                                        </div>
                                    </>
                                    :
                                    <div className='column is-12'>
                                        <FCLChargeClientViewv2 dummyContract={rec} subscript={subscript} cwfVisible={props.cwfVisible}/>
                                    </div>
                            }
                        </div>
                        {
                            (props.pricingRec?.hasDPD || '' + props.pricingRec?.additionalType == 'DPD') &&
                            <div className='columns'>
                                <div className='column is-12'>
                                    <GenericSwitch store={rtpStore} property='dpd' leftValue='Direct Port Delivery' rightValue=' ' />
                                </div>
                            </div>
                        }
                    </> : <></>
            }
            {
                showRateTabs &&
                <div style={{ marginTop: '0.5rem' }}>
                    {rec.costChargesList?.length > 0 && <p style={{ fontSize: '0.8rem', margin: '0 0 0.5rem' }}>
                        <strong>Cost saved:</strong> {Utils.N(rec.costQuoteValue)} | Gross Profit {Utils.N(rec.costProfit)} ({Number(rec.costProfitPercentage || 0).toFixed(2)}%)
                    </p>}
                    {rateTab === 'cost' && (editStore.costRoute === costRouteKey ? <>
                        <FCLChargesComp keylist="costlist" heading="Cost Rate" />
                        <div style={{ textAlign: 'right', marginTop: '0.5rem' }}>
                            <button type="button" className="button is-small is-link" onClick={saveCost}>Save Cost</button>
                        </div>
                    </> : <p style={{ fontSize: '0.8rem' }}>
                        The cost of another route is being edited.{' '}
                        <button type="button" className="button is-small is-text" onClick={openCostEditor}>Edit the cost of this route</button>
                    </p>)}
                    {costAlert && <FCLMarginAlert alert={costAlert} onClose={() => setCostAlert(null)}
                        onConfirm={() => { const l = costAlert.contract; setCostAlert(null); applyCost(l) }} />}
                </div>
            }</>}
         </>) :  
         <EntityCreWarnPopup cancelfn={(i)=>setEntityCreationPopup(false)} />
        }
        </div>
        )}
        </>
    )
}

export function Mobilelayoutfclschedule(props) {
    const [showCharges, setShowCharges] = useState(false)
    const [EntityCreationPopup, setEntityCreationPopup] = useState(false)
    const { currentMenu } = useGlobalState()

    useSnapshot(contractsStore)
    useSnapshot(bookingsStore)
    let brec = bookingsStore.current
    useSnapshot(configStore)
    useSnapshot(rtpStore)
    useSnapshot(cartingStore)
    useSnapshot(enquiryStore)
    useSnapshot(editStore)

    const logo = `assets/${process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE}/logo_name.svg`;

    let rec = props.rec || contractsStore.current
    if (props.contract) rec = props.contract
    let subscript = -1
    if (props.subscript >= 0) subscript = props.subscript

    let e = { ...props.data }
    let isDummy = props.isDummy ? true : false
    if (props.isDummy) {
        e = {
            'por': rec.portOfReceipt,
            'pol': rec.portOfLoading,
            'pod': rec.portOfDischarge,
            'fpod': rec.finalPlaceOfDelivery,
            'rep': rec.reworkingPort,
            'VESSEL NAME': '',
            'VOYAGE': '',
            'STUFFING CUT OFF DATE': '',
            'ETD (POL)': '',
            'ETA (POD)': '',
            'CO-LOADER': ''
        }
    }

    let grandTotal = 0.0
    let voldis = 0.0
    if (rec && rec['chargesList']) {
        rec['chargesList'].forEach(ch => {
            let erate = configStore.getExchangeRateinr(ch)
            if (!erate || erate === 0) erate = 1.0
            if (ch.chargeDescription === 'Volume Discount') {
                voldis = ch.total * erate
            } else if (ch.isIncluded === 'Yes') {
                grandTotal += ch.total * erate
            }
        })
    }

    let usdRate = configStore.getExchangeRate('USD')
    let grandusd = grandTotal / usdRate

    let exrate = 0
    let perchargelable = ""
    let Ocean_Freight_amount_inr = 0
    let Ocean_Freight_amount_usd = 0
    if (rec.shipmentScope === "Port-to-Port" && rec.chargesList) {
        for (let i = 0; i < rec.chargesList.length; i++) {
            if (rec.chargesList[i]['chargeDescription'] === 'Ocean Freight') {
                exrate = configStore.getExchangeRateinr(rec.chargesList[i])
                let k = Object.keys(rec.chargesList[i])
                for (let j = 0; j < k.length; j++) {
                    if (k[j].indexOf("perWM") !== -1) {
                        perchargelable = k[j].split('perWM')[0]
                        Ocean_Freight_amount_inr = rec.chargesList[i][k[j]] * exrate
                        if (rec.chargesList[i]['currency'] === 'USD') {
                            Ocean_Freight_amount_usd = rec.chargesList[i][k[j]]
                        }
                        j = k.length + 1
                    }
                }
            }
        }
    }

    let mainPrice = "";
    let usdPrice = "";

    if (!props.noprice) {
        if (rec.shipmentScope === "Port-to-Port" && rec.isCarting == undefined && brec?.isUpload == undefined && brec?.createbooking == undefined && Ocean_Freight_amount_usd > 0) {
            mainPrice = `${Utils.N(Ocean_Freight_amount_usd, 'USD')} Per ${perchargelable}`;
            usdPrice = Utils.N(Ocean_Freight_amount_inr);
        } else if (rec.quoteValue > 0) {
            mainPrice = Utils.N(rec.quoteValue - Utils.toNum(rec.quoteValueDeduction));
            usdPrice = Utils.N(rec.quoteValueUSD, "USD");
        } else {
            mainPrice = Utils.N(grandTotal);
            usdPrice = Utils.N(grandusd, "USD");
        }
    }

    let originLoc =  rec.origin
    let destLoc =  rec.destination

    let cutoffRaw = e.cutoffpor || e['STUFFING CUT OFF DATE'] || ''
    let cutoffDate = cutoffRaw ? (cutoffRaw.length > 11 ? Utils.formatDateShort(new Date(cutoffRaw)) : cutoffRaw) : 'N/A'

    let etaRaw = e.etapod || e['ETA (POD)'] || (e.pod !== e.fpod ? e.etafpod : '') || ''
    let etaDate = etaRaw ? (etaRaw.length > 11 ? Utils.formatDateShort(new Date(etaRaw)) : etaRaw) : 'N/A'

    let etdRaw = e.etdpol || e['ETD (POL)'] || ''
    let etdDate = etdRaw ? Utils.newDate(etdRaw) : null
    let etaDateObj = etaRaw ? Utils.newDate(etaRaw) : null
    let days = (etdDate && etaDateObj) ? Utils.getDays(etdDate, etaDateObj) : ''
    let transitTime = e.transitTime || days;

    let cscac = e.cscac || rec.scac || e['CO-LOADER'] || rec.coLoader || rec.shippingLine || rec.carrier || ''
    let carrierLogo = schLogoMap[cscac]
    if (!carrierLogo && brec && brec.iata && airlogoMap[brec.iata]) {
        carrierLogo = airlogoMap[brec.iata]
    }
    if (!carrierLogo) {
        carrierLogo = logo
    }

    return (
        <div style={{ display: 'block', width: '100%', maxWidth: '100%', overflow: 'hidden', padding: "4px 0px" }}>
            {/* White Card */}
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.04)',
                padding: '16px',
                marginBottom: '10px',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                overflow: 'hidden'
            }}>
                <div className='flex flex-row justify-end w-full my-2 gap-2'>
                    {(!props.nobutton && props.pricingRec && TenantUtils.isAgraga()) && (
                        <Button style={{ border: "1px solid #3878DE", borderRadius: "6px", fontSize: "12px", textTransform: "none" }} onClick={() => {
                            Api.saveQuoteNoTransform(props.pricingRec)
                        }}>
                            Save Quote
                        </Button>
                    )}
                    {(TenantUtils.isNavexel() && !props.mrg && !props.nobutton) && (
                        <Button style={{ border: "1px solid #3878DE", borderRadius: "6px", fontSize: "12px", textTransform: "none" }} onClick={async () => {
                            editStore.pricingRec = JSON.parse(JSON.stringify(props.pricingRec))
                            props.setOpenCopyMail && props.setOpenCopyMail(true)
                        }}>
                            Copy Mail
                        </Button>
                    )}
                    {(TenantUtils.isNavexel() && props.mrg && !props.nobutton) && (
                        <Button style={{ border: "1px solid #3878DE", borderRadius: "6px", fontSize: "12px", textTransform: "none" }} onClick={async () => {
                            editStore.pricingRec = JSON.parse(JSON.stringify(props.pricingRec))
                            props.setOpenCopyMail && props.setOpenCopyMail(true)
                        }}>
                            Copy MRG
                        </Button>
                    )}
                </div>
                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                    {/* Carrier Logo Box */}
                    <div style={{
                        width: '64px',
                        height: '64px',
                        minWidth: '64px',
                        maxWidth: '64px',
                        borderRadius: '8px',
                        backgroundColor: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        padding: '6px',
                        flexShrink: 0
                    }}>
                        <img src={carrierLogo} alt={cscac || 'Carrier'} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                    </div>

                    {/* Schedule Information */}
                    <div style={{ flex: 1, minWidth: 0, width: '0', overflow: 'hidden' }}>
                        {/* Price Row */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', width: '100%', minWidth: 0, gap: '6px' }}>
                            <div style={{ fontSize: '1.15rem', fontWeight: '700', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {!props.noprice && mainPrice}
                            </div>
                            <div style={{ fontSize: '1rem', fontWeight: '600', color: '#0f172a', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'right' }}>
                                {!props.noprice && usdPrice}
                            </div>
                        </div>

                        {/* Route Row with Ellipsis */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '8px 0', width: '100%', minWidth: 0, gap: '6px' }}>
                            <span
                                title={originLoc}
                                style={{
                                    fontWeight: '600',
                                    fontSize: '0.88rem',
                                    color: '#0f172a',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    flex: '1 1 0%',
                                    minWidth: 0
                                }}
                            >
                                {originLoc}
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0, width: '40px' }}>
                                <div style={{ borderBottom: '1px dotted #94a3b8', flex: 1, minWidth: '4px' }} />
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ margin: '0 2px', flexShrink: 0 }}>
                                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                                    <line x1="12" y1="22.08" x2="12" y2="12" />
                                </svg>
                                <div style={{ borderBottom: '1px dotted #94a3b8', flex: 1, minWidth: '4px' }} />
                            </div>
                            <span
                                title={destLoc}
                                style={{
                                    fontWeight: '600',
                                    fontSize: '0.88rem',
                                    color: '#0f172a',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    flex: '1 1 0%',
                                    minWidth: 0,
                                    textAlign: 'right'
                                }}
                            >
                                {destLoc}
                            </span>
                        </div>

                        {/* Cutoff & ETA Row */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.8rem', color: '#64748b', marginTop: '4px', width: '100%', minWidth: 0, gap: '6px' }}>
                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1 }}>
                                Cut off: <span style={{ color: '#334155' }}>{cutoffDate}</span>
                            </div>
                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0, flex: 1, textAlign: 'right' }}>
                                ETA: <span style={{ color: '#334155' }}>{etaDate}</span>
                            </div>
                        </div>

                        {/* Transit Time Badge */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px', width: '100%', minWidth: 0 }}>
                            <span style={{
                                backgroundColor: '#dbeafe',
                                color: '#1d4ed8',
                                borderRadius: '6px',
                                padding: '3px 10px',
                                fontSize: '0.78rem',
                                fontWeight: '500',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%',
                                display: 'inline-block'
                            }}>
                                {transitTime ? `Transit Time ${transitTime} Days` : "Schedule awaited"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* View Detailed Pricing Button */}
            {!props.noprice && (
                <button
                    onClick={() => setShowCharges(!showCharges)}
                    style={{
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        backgroundColor: '#ffffff',
                        border: '1.5px solid #3b82f6',
                        borderRadius: '8px',
                        padding: '11px 16px',
                        color: '#2563eb',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textAlign: 'center',
                        transition: 'background-color 0.2s, border-color 0.2s',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ffffff'}
                >
                    {showCharges ? 'Hide Detailed Pricing' : 'View Detailed Pricing'}
                </button>
            )}

            {/* Expanded Detailed Charges */}
            {!props.noprice && showCharges && (
                <div style={{ marginTop: '10px', width: '100%', boxSizing: 'border-box' }}>
                    <FCLBookingPricingDetail isAccordionView={true} disableInclusion={true} contract={rec} />
                </div>
            )}

            {EntityCreationPopup && (
                <EntityCreWarnPopup cancelfn={() => setEntityCreationPopup(false)} />
            )}
        </div>
    )
}